export const CBM_WIZARD_SET_ACTIVE_STEP = 'CBM_WIZARD_SET_ACTIVE_STEP';
export const CBM_WIZARD_SET_REPORT_TYPE = 'CBM_WIZARD_SET_REPORT_TYPE';
export const CBM_WIZARD_SET_REPORTING_YEAR = 'CBM_WIZARD_SET_REPORTING_YEAR';
export const CBM_WIZARD_SET_REPORTING_PERIOD = 'CBM_WIZARD_SET_REPORTING_PERIOD';
export const CBM_WIZARD_SET_SESSION_ID = 'CBM_WIZARD_SET_SESSION_ID';
export const CBM_WIZARD_FETCH_SELECT_ITEMS_REQUEST = 'CBM_WIZARD_FETCH_SELECT_ITEMS_REQUEST';
export const CBM_WIZARD_FETCH_SELECT_ITEMS_SUCCESS = 'CBM_WIZARD_FETCH_SELECT_ITEMS_SUCCESS';
export const CBM_WIZARD_FETCH_SELECT_ITEMS_FAILURE = 'CBM_WIZARD_FETCH_SELECT_ITEMS_FAILURE';
export const CBM_WIZARD_SAVE_DRAFT_REQUEST = 'CBM_WIZARD_SAVE_DRAFT_REQUEST';
export const CBM_WIZARD_SAVE_DRAFT_SUCCESS = 'CBM_WIZARD_SAVE_DRAFT_SUCCESS';
export const CBM_WIZARD_SAVE_DRAFT_FAILURE = 'CBM_WIZARD_SAVE_DRAFT_FAILURE';
export const CBM_WIZARD_EXTRACTION_TRIGGER_REQUEST = 'CBM_WIZARD_EXTRACTION_TRIGGER_REQUEST';
export const CBM_WIZARD_EXTRACTION_TRIGGER_SUCCESS = 'CBM_WIZARD_EXTRACTION_TRIGGER_SUCCESS';
export const CBM_WIZARD_EXTRACTION_TRIGGER_FAILURE = 'CBM_WIZARD_EXTRACTION_TRIGGER_FAILURE';
export const CBM_WIZARD_EXTRACTION_STATUS_REQUEST = 'CBM_WIZARD_EXTRACTION_STATUS_REQUEST';
export const CBM_WIZARD_EXTRACTION_STATUS_SUCCESS = 'CBM_WIZARD_EXTRACTION_STATUS_SUCCESS';
export const CBM_WIZARD_EXTRACTION_STATUS_FAILURE = 'CBM_WIZARD_EXTRACTION_STATUS_FAILURE';
export const CBM_WIZARD_EXTRACT_RECORDS_REQUEST = 'CBM_WIZARD_EXTRACT_RECORDS_REQUEST';
export const CBM_WIZARD_EXTRACT_RECORDS_SUCCESS = 'CBM_WIZARD_EXTRACT_RECORDS_SUCCESS';
export const CBM_WIZARD_EXTRACT_RECORDS_FAILURE = 'CBM_WIZARD_EXTRACT_RECORDS_FAILURE';
export const CBM_WIZARD_EXTRACT_LAYOUT_REQUEST = 'CBM_WIZARD_EXTRACT_LAYOUT_REQUEST';
export const CBM_WIZARD_EXTRACT_LAYOUT_SUCCESS = 'CBM_WIZARD_EXTRACT_LAYOUT_SUCCESS';
export const CBM_WIZARD_EXTRACT_LAYOUT_FAILURE = 'CBM_WIZARD_EXTRACT_LAYOUT_FAILURE';
export const CBM_WIZARD_HYDRATE_SESSION = 'CBM_WIZARD_HYDRATE_SESSION';
export const CBM_WIZARD_FETCH_TERMS_REQUEST = 'CBM_WIZARD_FETCH_TERMS_REQUEST';
export const CBM_WIZARD_FETCH_TERMS_SUCCESS = 'CBM_WIZARD_FETCH_TERMS_SUCCESS';
export const CBM_WIZARD_FETCH_TERMS_FAILURE = 'CBM_WIZARD_FETCH_TERMS_FAILURE';
export const CBM_WIZARD_SET_TERM = 'CBM_WIZARD_SET_TERM';
export const CBM_WIZARD_SET_EXTRACT_PAGE = 'CBM_WIZARD_SET_EXTRACT_PAGE';
export const CBM_WIZARD_SET_EXTRACT_PAGE_SIZE = 'CBM_WIZARD_SET_EXTRACT_PAGE_SIZE';
export const CBM_WIZARD_SET_EXTRACT_SEARCH = 'CBM_WIZARD_SET_EXTRACT_SEARCH';
export const CBM_WIZARD_SET_EXTRACT_SORT = 'CBM_WIZARD_SET_EXTRACT_SORT';
export const CBM_WIZARD_EXPORT_CSV_REQUEST = 'CBM_WIZARD_EXPORT_CSV_REQUEST';
export const CBM_WIZARD_EXPORT_CSV_SUCCESS = 'CBM_WIZARD_EXPORT_CSV_SUCCESS';
export const CBM_WIZARD_EXPORT_CSV_FAILURE = 'CBM_WIZARD_EXPORT_CSV_FAILURE';

export const CBM_WIZARD_EXPORT_PRECHECK_REPORT_REQUEST = 'CBM_WIZARD_EXPORT_PRECHECK_REPORT_REQUEST';
export const CBM_WIZARD_EXPORT_PRECHECK_REPORT_SUCCESS = 'CBM_WIZARD_EXPORT_PRECHECK_REPORT_SUCCESS';
export const CBM_WIZARD_EXPORT_PRECHECK_REPORT_FAILURE = 'CBM_WIZARD_EXPORT_PRECHECK_REPORT_FAILURE';

// Validation
export const CBM_WIZARD_VALIDATION_TRIGGER_REQUEST = 'CBM_WIZARD_VALIDATION_TRIGGER_REQUEST';
export const CBM_WIZARD_VALIDATION_TRIGGER_SUCCESS = 'CBM_WIZARD_VALIDATION_TRIGGER_SUCCESS';
export const CBM_WIZARD_VALIDATION_TRIGGER_FAILURE = 'CBM_WIZARD_VALIDATION_TRIGGER_FAILURE';
export const CBM_WIZARD_VALIDATION_STATUS_REQUEST = 'CBM_WIZARD_VALIDATION_STATUS_REQUEST';
export const CBM_WIZARD_VALIDATION_STATUS_SUCCESS = 'CBM_WIZARD_VALIDATION_STATUS_SUCCESS';
export const CBM_WIZARD_VALIDATION_STATUS_FAILURE = 'CBM_WIZARD_VALIDATION_STATUS_FAILURE';
export const CBM_WIZARD_VALIDATION_RESULTS_REQUEST = 'CBM_WIZARD_VALIDATION_RESULTS_REQUEST';
export const CBM_WIZARD_VALIDATION_RESULTS_SUCCESS = 'CBM_WIZARD_VALIDATION_RESULTS_SUCCESS';
export const CBM_WIZARD_VALIDATION_RESULTS_FAILURE = 'CBM_WIZARD_VALIDATION_RESULTS_FAILURE';
export const CBM_WIZARD_SET_VALIDATION_SEVERITY_FILTER = 'CBM_WIZARD_SET_VALIDATION_SEVERITY_FILTER';
export const CBM_WIZARD_SET_VALIDATION_REPORT_FILTER = 'CBM_WIZARD_SET_VALIDATION_REPORT_FILTER';
export const CBM_WIZARD_SET_VALIDATION_RULE_FILTER = 'CBM_WIZARD_SET_VALIDATION_RULE_FILTER';
export const CBM_WIZARD_SET_VALIDATION_FIELD_FILTER = 'CBM_WIZARD_SET_VALIDATION_FIELD_FILTER';
export const CBM_WIZARD_EXPORT_VALIDATION_ERRORS_REQUEST = 'CBM_WIZARD_EXPORT_VALIDATION_ERRORS_REQUEST';
export const CBM_WIZARD_EXPORT_VALIDATION_ERRORS_SUCCESS = 'CBM_WIZARD_EXPORT_VALIDATION_ERRORS_SUCCESS';
export const CBM_WIZARD_EXPORT_VALIDATION_ERRORS_FAILURE = 'CBM_WIZARD_EXPORT_VALIDATION_ERRORS_FAILURE';

// Export (Step 4)
export const CBM_WIZARD_EXPORT_SUMMARY_REQUEST = 'CBM_WIZARD_EXPORT_SUMMARY_REQUEST';
export const CBM_WIZARD_EXPORT_SUMMARY_SUCCESS = 'CBM_WIZARD_EXPORT_SUMMARY_SUCCESS';
export const CBM_WIZARD_EXPORT_SUMMARY_FAILURE = 'CBM_WIZARD_EXPORT_SUMMARY_FAILURE';

export const CBM_WIZARD_TRIGGER_EXPORT_REQUEST = 'CBM_WIZARD_TRIGGER_EXPORT_REQUEST';
export const CBM_WIZARD_TRIGGER_EXPORT_SUCCESS = 'CBM_WIZARD_TRIGGER_EXPORT_SUCCESS';
export const CBM_WIZARD_TRIGGER_EXPORT_FAILURE = 'CBM_WIZARD_TRIGGER_EXPORT_FAILURE';

export const CBM_WIZARD_EXPORT_STATUS_REQUEST = 'CBM_WIZARD_EXPORT_STATUS_REQUEST';
export const CBM_WIZARD_EXPORT_STATUS_SUCCESS = 'CBM_WIZARD_EXPORT_STATUS_SUCCESS';
export const CBM_WIZARD_EXPORT_STATUS_FAILURE = 'CBM_WIZARD_EXPORT_STATUS_FAILURE';

export const CBM_WIZARD_DOWNLOAD_EXPORT_REQUEST = 'CBM_WIZARD_DOWNLOAD_EXPORT_REQUEST';
export const CBM_WIZARD_DOWNLOAD_EXPORT_SUCCESS = 'CBM_WIZARD_DOWNLOAD_EXPORT_SUCCESS';
export const CBM_WIZARD_DOWNLOAD_EXPORT_FAILURE = 'CBM_WIZARD_DOWNLOAD_EXPORT_FAILURE';

export const CBM_WIZARD_DOWNLOAD_MANIFEST_REQUEST = 'CBM_WIZARD_DOWNLOAD_MANIFEST_REQUEST';
export const CBM_WIZARD_DOWNLOAD_MANIFEST_SUCCESS = 'CBM_WIZARD_DOWNLOAD_MANIFEST_SUCCESS';
export const CBM_WIZARD_DOWNLOAD_MANIFEST_FAILURE = 'CBM_WIZARD_DOWNLOAD_MANIFEST_FAILURE';

export const CBM_WIZARD_RESET = 'CBM_WIZARD_RESET';

// RCS sub-state
export const SET_RCS_P1_FIELD = 'cbmWizard/SET_RCS_P1_FIELD';
export const SET_RCS_P1_PREFILL = 'cbmWizard/SET_RCS_P1_PREFILL';
export const SET_RCS_EXTRACTED = 'cbmWizard/SET_RCS_EXTRACTED';
export const RCS_VALIDATION_LOADING = 'cbmWizard/RCS_VALIDATION_LOADING';
export const RCS_VALIDATION_LOADED = 'cbmWizard/RCS_VALIDATION_LOADED';
